var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupermoduleupdate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7502 22.75L21.6881 17.6069C22.0743 17.4065 22.2674 17.3075 22.408 17.1596C22.5325 17.0298 22.6268 16.8741 22.6842 16.7037C22.7502 16.5093 22.7502 16.293 22.7502 15.8579V6.29035M11.7502 22.75L1.8123 17.6069C1.42608 17.4065 1.23296 17.3075 1.09241 17.1596C0.967915 17.0298 0.873598 16.8741 0.816187 16.7037C0.750187 16.5093 0.750187 16.2918 0.750187 15.8555V6.29035M11.7502 22.75V11.673M22.7502 6.29035L11.7502 11.673M22.7502 6.29035L12.6424 1.05925C12.3161 0.890584 12.1535 0.805028 11.9812 0.772028C11.8286 0.742657 11.6718 0.742657 11.5192 0.772028C11.3481 0.805028 11.1843 0.890584 10.8567 1.05925L0.750187 6.29035M0.750187 6.29035L11.7502 11.673",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupermoduleupdate);
export default __webpack_public_path__ + "static/media/supermoduleupdate.63641fc9dac63f8286db857ff7b63a10.svg";
export { ForwardRef as ReactComponent };